import React, { useState } from 'react';
import CollapseButton from '../../../utilities/CollapseButton/CollapseButton';

const MeterDataBlock = ({transactionData}) => {
  const [isOpen, setIsOpen] = useState(false);

  const agreementNumber = transactionData?.generalDetails?.agreementNumber;
  const meterNumber = transactionData?.generalDetails?.meterNumber;
  const meterTypeRaw = transactionData?.generalDetails?.meterType?.toUpperCase();
  const meterType = meterTypeRaw === 'SMART' ? 'מונה חכם' : meterTypeRaw === 'BASIC' ? 'מונה בסיסי' : meterTypeRaw;
  const meterAddress = transactionData?.generalDetails?.meterAddress;

  const hasData = agreementNumber || meterNumber || meterType || meterAddress;

  return (
    hasData && (
      <div className='block-frame p-2'>
        <CollapseButton cardTitle='נתוני מונה' setIsOpen={setIsOpen} isOpen={isOpen} />
        {isOpen && (
          <div className='block-frame__container'>
            <div className='equipment-summary'>
              <hr />
              {agreementNumber && (
                <div className='block-frame__list-info'>
                  <div className='block-frame__row block-frame__row--2'>
                    <label>מספר חוזה</label>
                    <div className='block-frame__price-holder'><span>{agreementNumber}</span></div>
                  </div>
                </div>
              )}
              {meterNumber && (
                <div className='block-frame__list-info'>
                  <div className='block-frame__row block-frame__row--2'>
                    <label>מספר מונה</label>
                    <div className='block-frame__price-holder'><span>{meterNumber}</span></div>
                  </div>
                </div>
              )}
              {meterType && (
                <div className='block-frame__list-info'>
                  <div className='block-frame__row block-frame__row--2'>
                    <label>סוג מונה</label>
                    <div className='block-frame__price-holder'><span>{meterType}</span></div>
                  </div>
                </div>
              )}
              {meterAddress && (
                <div className='block-frame__list-info'>
                  <div className='block-frame__row block-frame__row--2'>
                    <label>כתובת מונה</label>
                    <div className='block-frame__price-holder'><span>{meterAddress}</span></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default MeterDataBlock;
